// removed by extract-text-webpack-plugin
module.exports = {"ToggleGroup":"toggleGroup__ToggleGroup__Fm7ef","ToggleElement":"toggleGroup__ToggleElement__3FpiU","ToggleButton":"toggleGroup__ToggleButton__3I5tc"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/ToggleGroup/toggleGroup.css
// module id = 913
// module chunks = 2